import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
